import $ from 'jquery';

import City from 'blocks/city/city';
import Animation from 'modules/animation/animation';
import Numbered from 'input.numbered';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaOrderSimDelivery',
			dom: {
				city: '.js-city',
				cityId: '#yotaOrderSimDeliveryCityId',
				cityCode: '#yotaOrderSimDeliveryCityCode',
				cityName: '#yotaOrderSimDeliveryCityName',
				cityJson: '#yotaOrderSimDeliveryCityJson',
				phone: '#yotaOrderSimDeliveryPhone',
				mnp: '#yotaOrderSimDeliveryMnp',
				express: '#yotaOrderSimDeliveryExpress',
				standart: '#yotaOrderSimDeliveryStandart',
				self: '#yotaOrderSimDeliverySelf'
			},
			classes: {
				mnp: 'b-order-sim-delivery_state_mnp',
				self: 'b-order-sim-delivery_state_self',
				standart: 'b-order-sim-delivery_state_standart',
				express: 'b-order-sim-delivery_state_express',
				field: {
					error: 'b-field_state_error'
				}
			},
			update: false
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.$window = $(window);
		this.priceDefault = 300;
		this.cityData = false;
		this.data = {};
		this.expressTime = {};
		return this;
	}

	getDom() {
		this.$city = this.$el.find(this.options.dom.city);
		this.$cityId = this.$el.find(this.options.dom.cityId);
		this.$cityCode = this.$el.find(this.options.dom.cityCode);
		this.$cityName = this.$el.find(this.options.dom.cityName);
		this.$cityJson = this.$el.find(this.options.dom.cityJson);
		this.$phone = this.$el.find(this.options.dom.phone);
		this.$mnp = this.$el.find(this.options.dom.mnp);
		this.$express = this.$el.find(this.options.dom.express);
		this.$standart = this.$el.find(this.options.dom.standart);
		this.$self = this.$el.find(this.options.dom.self);
		return this;
	}

	updatePrice(price) {
		if (this.options.update != false) {
			this.options.update(price);
		}
	}

	onCitySet(data) {
		if (this.cityData.id != data.id) {
			this.cityData = data;
			this.setDelivery(this.cityData[this.data.delivery] && this.cityData[this.data.express]);

			this.updatePrice(this.cityData[this.data.price]);

			this.$el
				.toggleClass(this.options.classes.self, !this.cityData[this.data.delivery])
				.toggleClass(this.options.classes.standart, this.cityData[this.data.delivery] && !this.cityData[this.data.express])
				.toggleClass(this.options.classes.express, this.cityData[this.data.delivery] && this.cityData[this.data.express])
				.toggleClass(this.options.classes.mnp, this.cityData[this.data.mnp]);


			this.$cityId.val(this.cityData.id);
			this.$cityCode.val(this.cityData.code);
			this.$cityName.val(this.cityData.name);
			this.$cityJson.val(JSON.stringify(this.cityData));

			const hrefSelf = this.$self.data('href')
								.replace('{#code}', this.cityData.code)
								.replace('{#center}', this.cityData.center)
								.replace('{#id}', this.cityData.id)
								.replace('{#map1}', this.cityData.map[0])
								.replace('{#map2}', this.cityData.map[1]);

			this.$self.attr('href', hrefSelf);
		}
		this.$window.trigger('resize');

	}

	validate() {
		let valid = true;
		const phone = this.$phone.val().replace(/[^\d]/gi, '');
		if (phone.length < 11) {
			this.$phone.parent().addClass(this.options.classes.field.error);
			$(() => new Animation({el: this.$phone.parent().parent().parent()}).play('shake'));
			valid = false;
		}
		return valid;
	}

	onFocusin(event) {
		const $target = $(event.currentTarget);
		$target.parent().removeClass(this.options.classes.field.error);
	}

	onSubmit(event) {
		const valid = this.validate();
		if (!valid) {
			event.preventDefault();
		}
	}

	setDelivery(express) {
		if (!this.$express.length || this.$express.prop('disabled')) {
			express = false;
		}
		this.$express.prop('checked', express);
		this.$standart.prop('checked', !express);
	}

	setData(data) {
		this.$mnp.prop('checked', data.mnp);
		this.$phone.val(data.phone);

		this.city
			.addData([data.city])
			.set(data.city.id, data.city.name)
			.set(data.city.id);

		this.setDelivery(data.delivery == this.$express.val());
	}

	render() {
		const self = this;
		if (self.$el.length) {
			if (yotaPortlets.orderSim) {
				self.data = yotaPortlets.orderSim;

				if (yotaPortlets.region && yotaPortlets.region.simStartPrice) {
					self.priceDefault = yotaPortlets.region.simStartPrice;
				}

				self.getDom();
				self.city = new City({
					el: self.$city,
					callback: {
						set: self.onCitySet.bind(self)
					}
				}).render();

				if (typeof self.data.data == 'object') {
					self.setData(self.data.data);
				}

				self.numbered = new Numbered(self.$phone, {placeholder: false});

				self.$el.on('submit', self.onSubmit.bind(self));
				self.$phone.on('focusin', self.onFocusin.bind(self));
			}
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/order-sim/delivery/delivery.js